<template>
  <b-modal ref="modal" size="xl" hide-footer>
		<div class="row">
			<div class="col-12 text-right">
    		<button class="btn btn-success" @click="print">Imprimir</button>
			</div>
		</div>

    <br/>

    <div id="printerContainer">
			<div class="page">

      <div class="card">
        <div class="card-body">

					<!-- cliente -->
          <div class="row">
            <div class="col-6">Cliente: {{ person.name }}</div>
          </div>
					
					<hr>

					<!-- produtos -->
					<div class="row">
						<div class="col-4">
							Produto
						</div>
						<div class="col-2">
							Quantidade
						</div>
						<div class="col-2">
							Preço
						</div>
						<div class="col-2">
							Total
						</div>
					</div>
					
					<hr>
					
					<div v-for="row in orderProducts" :key="row">
					
						<div class="row">
							<div class="col-4">
								{{ row.product }}
							</div>
							<div class="col-2">
								{{ row.quantity | decimal }}
							</div>
							<div class="col-2">
								{{ row.price | decimal }}
							</div>
							<div class="col-2">
								{{ row.quantity * row.price | decimal }}
							</div>
						</div>

					</div>

        </div>
      </div>
			</div>

			<div class="page" >

      <div class="card">
        <div class="card-body">

					<!-- cliente -->
          <div class="row">
            <div class="col-6">Cliente: {{ person.name }}</div>
          </div>
					
					<hr>

					<!-- produtos -->
					<div class="row">
						<div class="col-4">
							Produto
						</div>
						<div class="col-2">
							Quantidade
						</div>
						<div class="col-2">
							Preço
						</div>
						<div class="col-2">
							Total
						</div>
					</div>
					
					<hr>
					
					<div v-for="row in orderProducts" :key="row">
					
						<div class="row">
							<div class="col-4">
								{{ row.product }}
							</div>
							<div class="col-2">
								{{ row.quantity | decimal }}
							</div>
							<div class="col-2">
								{{ row.price | decimal }}
							</div>
							<div class="col-2">
								{{ row.quantity * row.price | decimal }}
							</div>
						</div>

					</div>

        </div>
      </div>
			</div>
    </div>
  </b-modal>
</template>

<script>

import Filters from "./../../mixins/Filters";

export default {
  data: function() {
    return {
			order: {},

			orderBills : {},

			orderProducts : {},

			person : {},
			
    };
  },

  methods: {
    open(order) {
      //console.log(order)
			
			this.select(order.id)
			
			this.$refs.modal.show();
    },

    select(id) {
      axios
        .get("../api/order/edit/" + id)
        .then(response => {
					console.log(response.data);

					this.order = response.data.order						
					this.orderBills = response.data.orderBills
					this.orderProducts = response.data.orderProducts
					this.person = response.data.person
          // this.form.setValues(response.data.order);

          // this.form.name.value = response.data.person.name;

          // this.products = response.data.orderProducts;

          // this.payments = response.data.orderBills;
        })
        .catch(error => {
          this.error = error;
        });
    },

    print() {
			//this.$htmlToPaper("printerContainer");
			//let routeData = this.$router.resolve({name: 'imprimir'});
			//window.open(routeData.href, '_blank');
			window.open("/vendas/imprimir/1", "_blank");  
    }
  }
};
</script>

<style>
</style>